// extracted by mini-css-extract-plugin
export default {"checkboxContainer":"Checkbox_checkboxContainer__85byz","customCheckbox":"Checkbox_customCheckbox__aOMvV","checkboxLabel":"Checkbox_checkboxLabel__gLVN5"};